'use client';

import type { FormEvent } from 'react';
import { useI18n } from '@fshr/context/i18n-context';
import Button from '../button';
import LoadingIndicator from '../loading-indicator';
import { StepperFormReview } from './stepper-form-review';
import type { ReviewStepSlotProps } from './types';

export function DefaultReviewStep({
	isFirstStep,
	nextButtonText,
	onBack,
	onStepComplete,
	sections,
	submitError,
	isSubmitting,
}: ReviewStepSlotProps) {
	const { t } = useI18n();

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		void onStepComplete({});
	};

	if (isSubmitting) {
		return (
			<div className="relative flex h-[300px] w-full items-center justify-center">
				<LoadingIndicator ppMode className="!absolute !inset-0 !z-0" />
			</div>
		);
	}

	return (
		<form noValidate className="flex w-full flex-col spacing-stack-l" onSubmit={handleSubmit}>
			<StepperFormReview title={t('Review')} sections={sections} errorMessage={submitError}>
				<div className="mt-[20px] flex w-full flex-row justify-center gap-[10px] md:mt-[10px] md:justify-end">
					<Button
						type="button"
						intent="outline"
						className="spacing-button-inline w-1/2 md:w-[130px]"
						disabled={isFirstStep}
						onClick={onBack}
					>
						{t('Back')}
					</Button>
					<Button type="submit" intent="filled" className="w-1/2 md:w-[130px]">
						{nextButtonText ?? t('Submit')}
					</Button>
				</div>
			</StepperFormReview>
		</form>
	);
}
